import { type AppContextType } from "@booking/types";
import { createContext } from "react";

export const AppContext = createContext<AppContextType>({
  appId: "",
  setAppId: () => {},
  profile: null,
  rootDOM: null,
});
